import { render } from "./AdmissionPartnersMgt.vue?vue&type=template&id=0ef48c46&scoped=true"
import script from "./AdmissionPartnersMgt.vue?vue&type=script&lang=js"
export * from "./AdmissionPartnersMgt.vue?vue&type=script&lang=js"

import "./AdmissionPartnersMgt.vue?vue&type=style&index=0&id=0ef48c46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef48c46"]])

export default __exports__